import React from "react";
import { getAppVersionLabel } from "../config/appVersion";

export default function HeaderBar({
  // Kept for backward compatibility with existing page imports/usages.
  // Header content is now rendered inside MenuBar as a merged top bar.
  companyName = "WINS AUTOS",
  period = "01/04/2026 TO 31/03/2027",
  version = getAppVersionLabel(),
  freeze = true,
}) {
  void companyName;
  void period;
  void version;
  void freeze;
  return null;
}
